import { selector, DefaultValue } from 'recoil';

import userState from './userState';
import { IUser } from './types';

export const loggedIn = selector({
  key: 'loggedIn',
  get: ({ get }) => get(userState.username) !== undefined,
});

export const isGuest = selector({
  key: 'isGuestSelector',
  get: ({ get }) => Boolean(get(userState.isGuest)),
});

export const user = selector<IUser>({
  key: 'userSelector',
  get: ({ get }) => ({
    username: get(userState.username),
    country: get(userState.country),
    id: get(userState.id),
    losses: get(userState.losses),
    rank: get(userState.rank),
    score: get(userState.score),
    wins: get(userState.wins),
    total: get(userState.total),
    activeGem: get(userState.activeGem),
    sparks: get(userState.sparks),
    xp: get(userState.xp),
    level: get(userState.level),
    xpIntoLevel: get(userState.xpIntoLevel),
    xpForNext: get(userState.xpForNext),
    emailVerified: get(userState.emailVerified),
    isGuest: get(userState.isGuest),
    hasEmail: get(userState.hasEmail),
  }),
  set: ({ set }, newUser) => {
    const isReset = newUser instanceof DefaultValue;

    set(userState.username, isReset ? newUser : newUser.username);
    set(userState.country, isReset ? newUser : newUser.country);
    set(userState.id, isReset ? newUser : newUser.id);
    set(userState.losses, isReset ? newUser : newUser.losses);
    set(userState.score, isReset ? newUser : newUser.score);
    set(userState.rank, isReset ? newUser : newUser.rank);
    set(userState.wins, isReset ? newUser : newUser.wins);
    set(userState.total, isReset ? newUser : newUser.total);
    set(userState.activeGem, isReset ? newUser : newUser.activeGem);
    set(userState.sparks, isReset ? newUser : newUser.sparks);
    set(userState.xp, isReset ? newUser : newUser.xp);
    set(userState.level, isReset ? newUser : newUser.level);
    set(userState.xpIntoLevel, isReset ? newUser : newUser.xpIntoLevel);
    set(userState.xpForNext, isReset ? newUser : newUser.xpForNext);
    set(userState.emailVerified, isReset ? newUser : newUser.emailVerified);
    set(userState.isGuest, isReset ? newUser : newUser.isGuest);
    set(userState.hasEmail, isReset ? newUser : newUser.hasEmail);
  },
});
